import * as React from "react";
import { TableCell } from "@mui/material";

interface QuantityCellProps {
  value?: number | null;
}

/** Renders a backend-reported quantity verbatim — right-aligned, no arithmetic performed. */
export function QuantityCell({ value }: QuantityCellProps): React.JSX.Element {
  const isMissing = value === null || value === undefined;
  return (
    <TableCell align="right" sx={{ fontVariantNumeric: "tabular-nums" }}>
      {isMissing ? (
        <span style={{ fontStyle: "italic", opacity: 0.6 }}>Not reported by backend</span>
      ) : (
        value
      )}
    </TableCell>
  );
}
